import classNames from 'classnames';
import { HTMLAttributes, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

interface ITabPanelProps extends HTMLAttributes<HTMLDivElement> {
  selected: boolean;
}

export function TabPanel({
  children,
  className,
  selected,
  ...rest
}: PropsWithChildren<ITabPanelProps>) {
  return (
    <div
      aria-hidden={selected}
      className={classNames(twMerge('', className), {
        block: selected,
        hidden: !selected,
      })}
      {...rest}
    >
      {children}
    </div>
  );
}
